(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('integration', {
            parent: 'settings',
            url: '/integration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.settings.integration.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/settings/integration/integration.html',
                    controller: 'IntegrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('active-integration', {
            parent: 'integration',
            url: '/active',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.settings.integration.active'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/settings/integration/active-integration.html',
                    controller: 'ActiveIntegrationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                itemsPerPageChosen: null,
                filter: null,
                search: {
                    value: '',
                    squash: true
                },
                domain: {
                    id: -1
                },
                scope: {
                    id: -1
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        search: $stateParams.search,
                        filter: $stateParams.filter,
                        domain: $stateParams.domain.id,
                        scope: $stateParams.scope.id
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('integration-edit', {
            parent: 'integration',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.settings.integration.edit'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/settings/integration/edit-integration.html',
                    controller: 'EditIntegrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Integration', function ($stateParams, Integration) {
                    return Integration.get({id: $stateParams.id});
                }]
            }
        })
        .state('delete-integration', {
            parent: 'active-integration',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/settings/integration/integration-delete-dialog.html',
                    controller: 'IntegrationDeleteDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Integration', function (Integration) {
                            return Integration.get({id: $stateParams.id});
                        }]
                    }
                }).result.then(function () {
                    $state.go('active-integration', null, {reload: true});
                }, function () {
                    $state.go('active-integration');
                });
            }]
        })
        .state('scope-dialog', {
            parent: 'integration',
            url: '/scope',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/settings/integration/scope-dialog.html',
                    controller: 'ScopeDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                }).result.then(function () {
                    $state.go('integration', null, {reload: true});
                }, function () {
                    $state.go('integration', null, {reload: true});
                });
            }]
        });
    }
})();
